export default __webpack_public_path__ + "static/media/img6.ef94358c.png";